import Rule from '../../rule';
import CopyrightAndLegalLinks from './copyright-and-legal-links';
import FlexcarAndSupportLinks from './flexcar-and-support-links';
import LogoAddressAndSocials from './logo-address-and-socials';

interface DirectoryProps {
  HEROKU_RELEASE_VERSION?: string;
  osanoEnabled?: boolean;
}

export default function Directory({
  HEROKU_RELEASE_VERSION,
  osanoEnabled,
}: DirectoryProps) {
  return (
    <div className="flex w-full flex-col gap-[24px]">
      <div className="flex w-full flex-col gap-[40px] sm:flex-row-reverse sm:justify-between">
        <FlexcarAndSupportLinks />
        <LogoAddressAndSocials />
      </div>

      <Rule direction="horizontal" color="bg-flexcar-neutral80" />

      <CopyrightAndLegalLinks
        HEROKU_RELEASE_VERSION={HEROKU_RELEASE_VERSION}
        osanoEnabled={osanoEnabled}
      />
    </div>
  );
}
